/**
 * stackLabels — 1-D placement for a column of chart labels that share an x.
 *
 * Each label wants to sit just above its own point. When two points are close
 * (Site 33.8% under Utilised 38.7%, Office 3.3% beside PTO 3.2%) their labels
 * collide, so: walk them bottom-up, keep each one as close to where it wants
 * to be as it can get without touching the one beneath it. If that pushes the
 * stack off the top of the plot, slide the whole stack back down.
 *
 * Pure and pixel-based on purpose - the chart does the value->pixel mapping,
 * this only guarantees `gap` pixels between baselines.
 *
 * ponytail: greedy, not optimal. With four labels a column it never needs to
 * be; a real solver is only worth it if a chart ever carries a dozen series.
 */
export function stackLabels(items, { gap = 11, top = -Infinity } = {}) {
  const lowestFirst = [...items].sort((a, b) => b.y - a.y); // larger y = lower on screen
  let above = Infinity;
  const placed = lowestFirst.map((it) => {
    const y = Math.min(it.y, above - gap);
    above = y;
    return { ...it, y };
  });
  const over = placed.length ? top - placed[placed.length - 1].y : 0;
  return over > 0 ? placed.map((it) => ({ ...it, y: it.y + over })) : placed;
}
